// Nachweis bei Übergabe und Abholung einer Veranstaltung: Unterschrift und/oder Foto – dasselbe Schema wie der Zustellnachweis
// (contract/afterDelivery.ts, docs/integration/bestell-app.md §22), damit die Bestell-App für alle Meldungen denselben Nachweis
// baut. Geprüft wird mit derselben Prüfung (server/proof.ts: decodeProofImage – Typ am Inhalt, lesbar für den PDF-Druck);
// Verträge mit Nachweis tragen die Rumpfgrenze PROOF_BODY_BYTES.
import { PROOF_IMAGE_TYPES, PROOF_LIMITS, type DeliveryProofInput, type ProofImageType, zDeliveryProofInput } from './afterDelivery'

export const EVENT_PROOF_TYPES = PROOF_IMAGE_TYPES
export type EventProofType = ProofImageType
/** Größte Bilder (entschlüsselt): Unterschrift 300 KB, Foto 2 MB */
export const EVENT_PROOF_LIMITS = PROOF_LIMITS
/** Unterschrift (≤ 300 KB) und/oder Foto (≤ 2 MB), je JPEG oder PNG – JPEG empfohlen */
export const zEventProof = zDeliveryProofInput
export type EventProofInput = DeliveryProofInput
